
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Table from '../../../../components/Common/Table';
import TableNoRecords from '../../../../components/Common/Table/TableNoRecords';
import Pagination from '../../../../components/Pagination';
import { Context } from '../../../../config/store';
import LenderUgroService from '../../../../services/lender';
import MandateModal from './MandateModal';
import tableColumns from './tableColum';
import './style.css'

const Mandate = ({ selectedLender, leadInfo, lafNumber }) => {
  const { state } = useContext(Context);
  const leadId = useParams().id;
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const mandateList = async () => {
    setLoading(true);
    let response = await LenderUgroService.getMandateDetail({
      lender_id: selectedLender,
      type: state.userType,
      subType: state.userType === 'admin' ? 'co-lender' : '',
      leadId: leadId,
    });
    setTableData(response?.data?.data?.mandate_detail);
    setLoading(false);
  };

  const [modalState, setModalState] = useState(false);

  const toggleModal = () => {
    setModalState(!modalState);
  };

  useLayoutEffect(() => {
    mandateList();
  }, [selectedLender, location.pathname]);

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  return (
    <div>
      <div className='row no-gutters justify-content-between align-items-center'>
        <div></div>
        <div className='mb-2'>
          {checkHasPermission('add-mandate') && [6].includes(leadInfo?.cl_lead_lender_status) && tableData.length === 0 && <button className='btn btn-custom' onClick={toggleModal}>
            Add Mandate
          </button>}
          {modalState && (
            <MandateModal
              userType={state.userType}
              state={modalState}
              toggleModal={toggleModal}
              leadId={leadId}
              lenderId={selectedLender}
              reloadTable={mandateList}
              selectedLender={selectedLender}
              lafNumber={lafNumber}
            />
          )}
        </div>
      </div>
      <div className='mandate_table'>
        <Table
          checkbox={false}
          columns={tableColumns}
          rows={tableData}
          loading={loading}
          reloadTable={mandateList}
          leadInfo={leadInfo}
        >
          {Boolean(!tableData.length && !loading) && <TableNoRecords />}
        </Table>
      </div>
    </div>
  );
};

export default Mandate;
